import { OSCI0110003Q } from "@/tz/go/egaz/osci/ptl/info/exrt/OSCI0110003Q";
import { OSCI0110001Q } from "@/tz/go/egaz/osci/ptl/info/hscd/OSCI0110001Q";
import { OSCI0110002Q } from "@/tz/go/egaz/osci/ptl/info/hscd/OSCI0110002Q";
import { Route, Routes } from "react-router-dom";
/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */
export const InfoRouter = () => {
    return (
        <Routes>
            {/* !== 환율 관리 ==! */}
            <Route path={"/excrt/osci0110003q"} element={<OSCI0110003Q />} />

            {/* !== HS Code 조회 ==! */}
            <Route path={"/hscd/osci0110001q"} element={<OSCI0110001Q />} />
            <Route path={"/hscd/osci0110002q/:id"} element={<OSCI0110002Q />} />
        </Routes>
    );
};
